import ConfiguracionEmpleado from 'components/empleados/ConfiguracionEmpleado'
import { useAuth } from 'context/AuthProvider'
import React from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'

const ViewEmpleadoConfiguracion = () => {
  const {empleado, empresa} = useAuth()
  const { id } = useParams()
  const empresaId = id || empresa?.id
  return (
    <Row>
    <Col>
        <Card>
            <CardHeader>
              Configuración:
            </CardHeader>
            <CardBody>  
                <ConfiguracionEmpleado empleadoId={empleado?.id} empresaId={empresaId}></ConfiguracionEmpleado>
            </CardBody>
        </Card>
    </Col>
</Row>
  )
}

export default ViewEmpleadoConfiguracion